import { render, staticRenderFns } from "./ModalUpdateStatus.vue?vue&type=template&id=0a08ea76"
import script from "./ModalUpdateStatus.vue?vue&type=script&lang=js"
export * from "./ModalUpdateStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports